module.exports = __webpack_public_path__ + "img/addon-eventsaascore.c50c635e.png";